import { render, staticRenderFns } from "./WorkIconWork.vue?vue&type=template&id=91aace24"
import script from "./WorkIconWork.vue?vue&type=script&lang=js"
export * from "./WorkIconWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports